// ClassContext.jsx
import React, { createContext, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { createDirectus, readItems, rest } from '@directus/sdk';
import { fetchWithRetry } from '../utils/fetchWithRetry';

const client = createDirectus('https://admin.thirsty-shtern.91-151-16-181.plesk.page').with(rest({credentials: 'include'}));

export const ClassContext = createContext();

export const ClassProvider = ({ children }) => {
  const [klassen, setKlassen] = useState([]);
  const [loadingKlassen, setLoadingKlassen] = useState(true);
  const [errorKlassen, setErrorKlassen] = useState(null);

  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const isPreview = query.get('preview') === 'true';
  const token = query.get('token');
  const version = query.get('version');

  useEffect(() => {
    const ac = new AbortController();

    const fetchKlassen = async () => {
      setLoadingKlassen(true); setErrorKlassen(null);
      try {
        if (isPreview && token) {
          await client.auth.static(token);
        }
        const res = await fetchWithRetry(
          /* () => client.items('Klassen').readByQuery({
            fields: ['*.*.*,Zusatzausbildungen.related_Klassen_id.Icon.*'],
            limit: 1500,
            version: version ?? undefined,
          }),
          { retries: 3, baseDelay: 300, signal: ac.signal } */
           () => client.request(readItems('Klassen', {
            filter: { status: { _eq: 'published' } },
            fields: ['*.*.*'],
            limit: 1500,
            version: version ?? undefined,
          })),
          { retries: 3, baseDelay: 300, signal: ac.signal }
        );
        console.log(res);
        setKlassen(res ?? []);
      } catch (e) {
        /* if(client.isCancel(e)) {console.log(e); } */
        if (!ac.signal.aborted) setErrorKlassen(`Fehler beim Laden der Klassen: ${e.message}`);
      } finally {
        if (!ac.signal.aborted) setLoadingKlassen(false);
      }
    };

    fetchKlassen();
    /* return () => ac.abort(); */
  }, [isPreview, token, version]);

  return (
    <ClassContext.Provider value={{ klassen, loadingKlassen, errorKlassen }}>
      {children}
    </ClassContext.Provider>
  );
};
